import React, { createContext, useContext, useState } from 'react';

type ManagedAccessDrawerContextValue = {
  managedAccessDrawerOpen: boolean;
  setManagedAccessDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const ManagedAccessDrawerContext = createContext<
  ManagedAccessDrawerContextValue | undefined
>(undefined);

export const useManagedAccessDrawerContext = () => {
  const managedAccessDrawerContext = useContext(ManagedAccessDrawerContext);

  if (managedAccessDrawerContext === undefined) {
    throw new Error(
      'useManagedAccessDrawerContext must be used within a ManagedAccessDrawerContextProvider',
    );
  }

  return managedAccessDrawerContext;
};

export const ManagedAccessDrawerContextProvider: React.FC = ({ children }) => {
  const [managedAccessDrawerOpen, setManagedAccessDrawerOpen] = useState(false);

  return (
    <ManagedAccessDrawerContext.Provider
      value={{
        managedAccessDrawerOpen,
        setManagedAccessDrawerOpen,
      }}
    >
      {children}
    </ManagedAccessDrawerContext.Provider>
  );
};
